const models = [
    'K1S',
    'CLF',
    'SD',
    'CV'
  ];

  export default models;


// WEBPACK FOOTER //
// ./src/data/vehicleModels.js